import cc from 'store/util/createReduxConstant';

export const FETCH_DISCOUNT_SUGGESTIONS = cc('FETCH_DISCOUNT_SUGGESTIONS');
export const FETCH_DISCOUNT_SUGGESTIONS_SUCCESS = cc('FETCH_DISCOUNT_SUGGESTIONS_SUCCESS');
export const FETCH_DISCOUNT_SUGGESTIONS_FAIL = cc('FETCH_DISCOUNT_SUGGESTIONS_FAIL');
